import {createContext} from 'react';

interface ModalDetailsStorage {
  isMobileModal: boolean;
  panelId: string;
}

export const ModalDetails = createContext<ModalDetailsStorage | null>(null);
